import React, { useState, useEffect } from 'react'
import moment from 'moment'
import CACDashboard from './CACDashboard';
import IncomeExpenses from './IncomeExpenses';
import TicketSize from './TickerSize';
import ApprovedLoans from './ApprovedLoan';
import CollectionEfficiency from './CollectionEfficiency';
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import { getNBFCList } from './ActionCreator'
import cac1 from './Icons/cac1.png'
import cac2 from './Icons/cac2.png'
import ticket1 from './Icons/ticket1.png'
import ticket2 from './Icons/ticket2.png'
import collection1 from './Icons/collection1.png'
import collection2 from './Icons/collection2.png'
import loans1 from './Icons/loans1.png'
import loans2 from './Icons/loans2.png'
const BackBtnStyle = {
    height: '50px',
    width: '100px',
    padding: '10px',
    textAlign: 'center',
    backgroundColor: '#006c67',
    color: '#fff',
    marginRight: '2px',
    cursor: 'pointer',
}

const BackBtnStyle2 = {
    fontSize: '18px',
    color: '#fff',
    fontWeight: '400',
    display: 'flex',
    background: '#006c67',
    cursor: 'pointer',
    padding: '12px 20px',
    boxShadow: 'inset -4px -4px 4px 0px #1d252d'
}

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

export default function main({ pageViewHandler, admin }) {
    const [nbfcList, setnbfcList] = useState([])
    const [tab, setTab] = useState('cac');
    const [fromDate, setFromDate] = useState(InitalDate('fromDate'))
    const [toDate, setToDate] = useState(InitalDate('toDate'))
    const [applyFilter, setapplyFilter] = useState(false);
    const [clearFilter, setclearFilter] = useState(false);
    const [clearbtnShow, setClearBtnShow] = useState(false);
    const [ActiveMonthFilter, setActiveMonthFilter] = useState('3month')
    const [edit, setEdit] = useState(false)

    useEffect(() => {
        getNBFCListAPI()
    }, [])


    const getNBFCListAPI = () => {
        getNBFCList((callback) => {
            console.log(callback)
            if (callback) {
                setnbfcList(callback)
            } else {
                setnbfcList([])
            }
        })
    }

    const handleTabs = (type) => {
        setTab(type)
        setEdit(false)
        setActiveMonthFilter('3month')
        setFromDate(InitalDate('fromDate'))
        setToDate(InitalDate('toDate'))
        setclearFilter(true)
        setClearBtnShow(false)
    }

    const handleDate = (e, type) => {
        if (type === 'fromDate') {
            setFromDate(e.target.value)
            setClearBtnShow(true)

        } else if (type === 'toDate') {
            setToDate(e.target.value)
            setClearBtnShow(true)

        } else if (type === 'applyFilter') {
            setapplyFilter(true);
        } else if (type === 'clearFilter') {
            setclearFilter(true)
            setClearBtnShow(false)
            setActiveMonthFilter('3month')
            setFromDate(InitalDate('fromDate'))
            setToDate(InitalDate('toDate'))
        }
    }

    const handleApplyFilter = () => {
        setapplyFilter(false)
    }
    const handleclearFilter = () => {
        setclearFilter(false)
    }

    const handlemonthFilter = (type) => {
        setActiveMonthFilter(ActiveMonthFilter === type ? '' : type)
        setClearBtnShow(true)
    }

    const handleEdit = () => {
        setEdit(!edit)
    }

    return (
        <>
            <div className="container-fluid details-new fixed-top" style={{ zIndex: '3' }} >
                <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                    <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px' }}>
                        <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                    </div>

                    <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>


                        <div className="btn-group-new">
                            <button className={(tab === 'cac') ? "active" : ""} style={{ fontSize: '14px' }} onClick={() => handleTabs('cac')}>
                                 <img src={ (tab === 'cac') ? cac2 : cac1} width={"24px"}/>
                                 <br /> CAC</button>
                            <button className={(tab === 'ticketSize') ? "active" : ""} style={{ fontSize: '14px' }} onClick={() => handleTabs('ticketSize')}> 
                                <img src={ (tab === 'ticketSize') ? ticket2 : ticket1} width={"24px"}/>
                                <br />Ticket Size</button>
                            <button className={(tab === 'approvedLoans') ? "active" : ""} style={{ fontSize: '14px' }} onClick={() => handleTabs('approvedLoans')}>  <img src={ (tab === 'approvedLoans') ? loans2 : loans1} width={"24px"}/><br />Approved Loans</button>
                            
                            <button className={(tab === 'collectionEfficiency') ? "active" : ""} style={{ fontSize: '14px' }} onClick={() => handleTabs('collectionEfficiency')}>  <img src={ (tab === 'collectionEfficiency') ? collection2 : collection1} width={"24px"}/><br />Collection Efficiency</button>
                        </div>

                    </div>
                </div>
            </div>
            <div className="MISDashboard" style={{marginTop:'100px'}}>
                {/* <div className="tabs">

                    <div className="" style={BackBtnStyle} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                        <ExitToAppIcon style={{ fontSize: '30px', margin: '0px 0px 10px 0px', transform: 'rotateY(180deg)' }} />
                    </div>
                    <div style={{ padding: '5px' }} className={`subtabss ${tab === 'cac' ? 'active' : ''}`} onClick={() => handleTabs('cac')}>
                        <h5 style={{ margin: '10px 0px', fontSize: window.innerWidth > 1300 ? '16px' : '14px' }}>CAC</h5>
                    </div>
                    <div style={{ padding: '5px' }} className={`subtabss ${tab === 'ticketSize' ? 'active' : ''}`} onClick={() => handleTabs('ticketSize')}>
                        <h5 style={{ margin: '10px 0px', fontSize: window.innerWidth > 1300 ? '16px' : '14px' }}>Ticket Size</h5>
                    </div>
                    <div style={{ padding: '5px' }} className={`subtabss ${tab === 'approvedLoans' ? 'active' : ''}`} onClick={() => handleTabs('approvedLoans')}>
                        <h5 style={{ margin: '10px 0px', fontSize: window.innerWidth > 1300 ? '16px' : '14px' }}>Approved Loans</h5>
                    </div>
                    <div style={{ padding: '5px' }} className={`subtabss ${tab === 'collectionEfficiency' ? 'active' : ''}`} onClick={() => handleTabs('collectionEfficiency')}>
                        <h5 style={{ margin: '10px 0px', fontSize: window.innerWidth > 1300 ? '16px' : '14px' }}>Collection Efficiency</h5>
                    </div>
                    <div style={{ padding: '5px' }} className={`subtabss ${tab === 'incomeExpenses' ? 'active' : ''}`} onClick={() => handleTabs('incomeExpenses')}>
                        <h5 style={{ margin: '10px 0px', fontSize: window.innerWidth > 1300 ? '16px' : '14px' }}>Income & Expenses</h5>
                    </div>
                </div> */}


                <div className="Sections">
                    <div className="subSections" style={{ position: 'relative' }}>
                        {
                            tab === "incomeExpenses" ?
                                <>
                                    <div className="Editbox">
                                        <button className='editbtn' onClick={() => handleEdit()}>{edit ? 'Close' : 'Edit'}</button>
                                    </div>
                                    <div className="Filterations">
                                        <div className="row">
                                            <div className="col-lg-2 col-md-4 col-sm-3 col-xs-12">
                                                <div className="inputgrp">
                                                    <label htmlFor="fromDate" className='inputlabel'>From</label>
                                                    <input type="date" id='fromDate' className='inputtag' value={fromDate} onChange={(e) => handleDate(e, 'fromDate')} disabled={edit ? true : false} />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-3 col-xs-12">
                                                <div className="inputgrp">
                                                    <label htmlFor="toDate" className='inputlabel'>To</label>
                                                    <input type="date" id='toDate' className='inputtag' value={toDate} min={fromDate} onChange={(e) => handleDate(e, 'toDate')} disabled={edit ? true : false} />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-3 col-xs-12">
                                                <div className="inputgrp">
                                                    <label htmlFor="toDate" className='inputlabel'>NBFC</label>
                                                    <select className='form-control'>

                                                    </select>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="row" style={{ marginTop: '10px' }}>
                                            <div className="col-lg-4 col-md-6 col-sm-8 col-xs-12" style={{ marginTop: '20px' }}>
                                                <div className="inputgrp">
                                                    <label className='inputlabel'>Month Filter</label>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <button className={`filterbtn2 ${ActiveMonthFilter === '3month' ? 'active' : ''}`} onClick={() => handlemonthFilter('3month')} disabled={edit ? true : false} >last 3 Month</button>
                                                        <button className={`filterbtn2 ${ActiveMonthFilter === '6month' ? 'active' : ''}`} onClick={() => handlemonthFilter('6month')} disabled={edit ? true : false} >last 6 Month</button>
                                                        <button className={`filterbtn2 ${ActiveMonthFilter === '1year' ? 'active' : ''}`} onClick={() => handlemonthFilter('1year')} disabled={edit ? true : false} >last 1 Year</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ marginTop: '20px' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <button className='btn btn-primary' style={{ marginTop: '48px', marginRight: '20px' }} onClick={(e) => handleDate(e, 'applyFilter')} disabled={edit ? true : false}>Apply Filter</button>
                                                    {
                                                        clearbtnShow ?
                                                            <button className='filterbtnReverse' style={{ marginTop: '48px' }} onClick={(e) => handleDate(e, 'clearFilter')} disabled={edit ? true : false}>Clear Filter</button>
                                                            : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </>
                                : ''}

                        {
                            tab === 'cac' ?
                                <CACDashboard nbfcList={nbfcList} admin={admin} />
                                : ''}
                        {
                            tab === 'ticketSize' ?
                                <TicketSize nbfcList={nbfcList} admin={admin} />
                                : ''}
                        {
                            tab === 'approvedLoans' ?
                                <ApprovedLoans nbfcList={nbfcList} admin={admin} />
                                : ''}
                        {
                            tab === 'collectionEfficiency' ?
                                <CollectionEfficiency nbfcList={nbfcList} admin={admin} />
                                : ''}
                        {
                            tab === 'incomeExpenses' ?
                                <IncomeExpenses fromDate={fromDate} toDate={toDate} handleApplyFilter={handleApplyFilter} applyFilter={applyFilter} clearFilter={clearFilter} handleclearFilter={handleclearFilter} edit={edit} handleEdit={handleEdit} ActiveMonthFilter={ActiveMonthFilter} />
                                : ''}


                    </div>
                </div>
            </div>
        </>
    )
}
